import { NoteCardController } from '../controller/NoteCardController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { Note } from '../../types';

export class NoteCardWebComponent extends BaseWebComponentElement {
  get note() {
    const value = this.getAttribute('data-note');
    return value ? JSON.parse(value) : {};
  }

  set note(note: Note) {
    this.setAttribute('data-note', JSON.stringify(note));
  }

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: NoteCardController,
    });
  }
}
